import env from '@config/env';
import { getDefaultHomePath } from '@config/routes';
import { isChunkLoadError, reloadOnceOnChunkError } from '@utils/chunkLoadError';
import { Result, Button } from 'antd';
import { Component } from 'react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    if (isChunkLoadError(this.state.error)) {
      reloadOnceOnChunkError(this.state.error, { force: true });
      return;
    }

    this.setState({ hasError: false, error: null });
    window.location.href = getDefaultHomePath();
  };

  render() {
    if (this.state.hasError) {
      const chunkError = isChunkLoadError(this.state.error);
      return (
        <div className="flex min-h-screen items-center justify-center p-3 desktop:p-4">
          <Result
            status="error"
            title="Something went wrong"
            subTitle={this.state.error?.message || 'An unexpected error occurred'}
            extra={
              <Button type="primary" onClick={this.handleReset}>
                {chunkError
                  ? 'Reload page'
                  : env.APP_TYPE === 'merchant'
                    ? 'Go to Launch Pad'
                    : 'Go to Dashboard'}
              </Button>
            }
          />
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
